export const LIST_MODAL_HEADER_TYPES = {
  threeDots: 'dots-three-vertical',
  addLog: 'add-log',
};
